module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-face-feeling-svgrepo-com.7d49025b.svg";